import React from "react";
import { useLang } from "@/context/LanguageContext";

export function GradeBadge({ grade, className = "" }) {
  if (!grade) return <span data-testid="grade-badge-empty" className={`status-chip pace-none ${className}`}>–</span>;
  const cls = grade === "A" ? "grade-A" : grade === "B" ? "grade-B" : "grade-C";
  return (
    <span data-testid={`grade-badge-${grade}`} className={`status-chip ${cls} ${className}`}>
      {grade}
    </span>
  );
}

export function PaceFlag({ flag, className = "", label }) {
  const cls = flag === "red" ? "pace-red" : flag === "amber" ? "pace-amber" : flag === "green" ? "pace-green" : "pace-none";
  return (
    <span data-testid={`pace-flag-${flag}`} className={`status-chip ${cls} ${className}`}>
      {label ?? flag}
    </span>
  );
}

export function StatusChip({ status, className = "" }) {
  const { t } = useLang();
  const map = {
    "Draft - ETA Missing": "pace-red",
    "Pending Inspector Assignment": "pace-amber",
    "Issued": "pace-green",
    "Raw Material Issued": "pace-green",
    "In Progress (Daura)": "pace-green",
    "Final QC": "pace-amber",
    "Received": "pace-green",
    "Reconciliation": "pace-none",
    "Closed": "pace-none",
    "Cancelled": "pace-red",
    "Idle": "pace-none",
    "Active": "pace-green",
    "Stopped": "pace-red",
    "Open": "pace-red",
    "In Progress": "pace-amber",
    "Resolved": "pace-green",
    "Pending": "pace-amber",
    "On Loom": "pace-amber",
    "Woven": "pace-green",
    "Returned": "pace-red",
  };
  const cls = map[status] || "pace-none";
  const label = t(`st.${status}`);
  return <span className={`status-chip ${cls} ${className}`}>{label && label !== `st.${status}` ? label : status}</span>;
}
